import { useContent } from "src/shared/components/content";
import { useAssetsUrl } from "src/shared/hooks/useAssetsUrl";
import { FAN_PROTECT_GUARANTEE_CONTENT_ID } from "src/website-apps/shared/components/brand-guarantee/constants";
import { Image } from "src/website-apps/shared/components/image";
import { FanProtectLink } from "./FanProtectLink";

/**
 * Fan Protect Image and Link
 * @param {object} props - props
 * @param props.isMobile - flag determing if mobile or tablet experience
 * @returns JSX Element
 */
export const FanProtectImageWithLink = ({ isMobile }) => {
  const assetsUrl = useAssetsUrl();
  const fanProtectImageAlt = useContent(FAN_PROTECT_GUARANTEE_CONTENT_ID);

  return (
    <FanProtectLink>
      <Image
        size={isMobile ? { height: 40, width: 140 } : { height: 50, width: 175 }}
        alt={fanProtectImageAlt}
        src={`${assetsUrl}/images/Assets/Icons/bfx/fanprotect.724c822d.svg`}
      />
    </FanProtectLink>
  );
};
